<!-- The generator picker of the palette and gradient tools (owner 2026-10-12): each generator drawn as where
     its colours sit on the wheel, with a line on what it makes; Codigrate Themes opens the themes to pick one. -->
<span class="ps-label">Generator</span>
<button type="button" class="ps-gen-btn" [class.open]="genOpen" (click)="toggleGen( $any( $event.currentTarget ) )"
        aria-haspopup="dialog" [attr.aria-expanded]="genOpen">
  <ng-container *ngTemplateOutlet="glyph; context: { $implicit: currentGen }"></ng-container>
  <!-- a picked theme shows its name with its five colours under it, as in the list (owner 2026-10-13) -->
  <span class="ps-gen-text" *ngIf="currentGen?.key === 'theme' && currentTheme; else genText">
    <span class="ps-gen-name">{{ currentTheme.name }}</span>
    <span class="ps-theme-colors" aria-hidden="true"><i *ngFor="let c of currentTheme.colors" [style.background]="c"></i></span>
  </span>
  <ng-template #genText>
    <span class="ps-gen-text">
      <span class="ps-gen-name">{{ currentGen ? currentGen.label : 'Select Generator' }}</span>
      <span class="ps-gen-desc">{{ currentGenDesc }}</span>
    </span>
  </ng-template>
  <app-icon class="ps-gen-caret" name="chevron-right" aria-hidden="true"></app-icon>
</button>

<div class="ps-gen-pop" *ngIf="genOpen" role="dialog" aria-label="Generators" [style.max-height.px]="genMaxHeight" (click)="$event.stopPropagation()">
  <ng-container *ngIf="!themeView">
    <button type="button" class="ps-gen-opt" *ngFor="let g of gens" [class.on]="g.key === selectedScheme"
            (click)="pickGen( g.key )">
      <ng-container *ngTemplateOutlet="glyph; context: { $implicit: g }"></ng-container>
      <span class="ps-gen-text">
        <span class="ps-gen-name">{{ g.label }}</span>
        <span class="ps-gen-desc">{{ g.desc }}</span>
      </span>
      <app-icon *ngIf="g.key === 'theme'" class="ps-gen-more" name="chevron-right" aria-hidden="true"></app-icon>
    </button>
  </ng-container>

  <ng-container *ngIf="themeView">
    <button type="button" class="ps-gen-back" (click)="themeView = false">
      <app-icon name="chevron-left" aria-hidden="true"></app-icon>Codigrate Themes
    </button>
    <div class="ps-theme-grid">
      <button type="button" class="ps-theme" [class.on]="!selectedTheme" (click)="pickTheme( '' )">
        <span class="ps-aio"><img src="./assets/product-lines/tools/all-in-one-themes.png" alt="" aria-hidden="true"/></span>
        <span class="ps-theme-name">Random Theme</span>
      </button>
      <button type="button" class="ps-theme" *ngFor="let t of themes" [class.on]="selectedTheme === t.key"
              (click)="pickTheme( t.key )">
        <img class="ps-theme-logo" [src]="t.logo" alt="" aria-hidden="true"/>
        <span class="ps-theme-text">
          <span class="ps-theme-name">{{ t.name }}</span>
          <!-- the theme's five colours under its name, as in the Appearance menu (owner 2026-10-13) -->
          <span class="ps-theme-colors" *ngIf="t.colors.length" aria-hidden="true"><i *ngFor="let c of t.colors" [style.background]="c"></i></span>
        </span>
      </button>
    </div>
  </ng-container>
</div>

<!-- A generator's glyph: the wheel with a dot at each hue it uses (a theme's logo, an image's picture icon). -->
<ng-template #glyph let-g>
  <span class="ps-glyph" [ngSwitch]="g?.key">
    <ng-container *ngSwitchCase="'theme'">
      <img *ngIf="currentTheme && g === currentGen; else aio" class="ps-glyph-logo" [src]="currentTheme.logo" alt="" aria-hidden="true"/>
      <ng-template #aio><span class="ps-aio"><img src="./assets/product-lines/tools/all-in-one-themes.png" alt="" aria-hidden="true"/></span></ng-template>
    </ng-container>
    <span *ngSwitchCase="'featured'" class="ps-glyph-featured"></span>
    <span *ngSwitchCase="'image'" class="ps-glyph-icon"><app-icon name="image" aria-hidden="true"></app-icon></span>
    <ng-container *ngSwitchDefault>
      <span class="ps-wheel"></span>
      <span class="ps-dot" *ngFor="let d of ( g?.dots || [] )"
            [style.background]="d.color" [style.transform]="'rotate(' + d.angle + 'deg) translateY(-' + d.r + 'px) rotate(-' + d.angle + 'deg)'"></span>
    </ng-container>
  </span>
</ng-template>
